package app.smartcoding.realrate.presentation.util

import app.smartcoding.realrate.domain.tools.toDoubleOrZero
import kotlin.math.absoluteValue
import kotlin.math.log10
import kotlin.math.pow
import kotlin.math.round

fun String.filterToDoubleString(
    delta: Double,
    minNumber: Double,
    maxNumber: Double,
    isInt: Boolean,
): String {
    val maxNumber = maxOf(minNumber,maxNumber)
    if (isBlank() && delta == 0.0) return ""
    if (this == "-") return "-"

    val decimal = filter { it.isDigit() || it == '.' || it == '-' }
    val isNegative = decimal.startsWith('-')
    val minNumberIntPartLength = minNumber.toLong().toString().dropWhile { it == '-' }.length
    val maxNumberIntPartLength = maxNumber.toLong().toString().length

    val prefix = decimal
        .trimStart('-')
        .takeWhile(Char::isDigit)

    val suffix = decimal
        .dropWhile { it != '.' }
        .filter(Char::isDigit)
        .takeIf { it.isNotBlank() && !isInt }

    val n = prefix
        .take(if (isNegative) minNumberIntPartLength else maxNumberIntPartLength)
        .plus(suffix?.filter(Char::isDigit)?.take(2)?.let { ".$it" } ?: "")
        .let { if (isNegative) "-$it" else it }
        .toDoubleOrZero()

    val coerceIn = if (delta.absoluteValue >= 10.0) {
        val exp = 10.0.pow(log10(delta.absoluteValue).toInt())
        (((n + delta) / exp).toLong() * exp).coerceIn(minNumber.rangeTo(maxNumber))
    } else {
        (n + delta).coerceIn(minNumber.rangeTo(maxNumber))
    }
    return when {
        coerceIn % 1.0 == 0.0 && delta == 0.0 -> {
            coerceIn.toLong().toString() + when {
                last() == '.' && !isInt -> '.'
                takeLast(2) == ".0" -> ".0"
                else -> ""
            }
        }

        coerceIn % 1.0 == 0.0 && delta != 0.0 -> {
            coerceIn.toLong().toString()
        }

        else -> {
            val sign = if (coerceIn <= 0.0) "-" else ""
            val numberTimes100Abs = round(coerceIn * 100).toLong().absoluteValue
            val integralPart = numberTimes100Abs / 100
            val fractionPart = (numberTimes100Abs % 100).toString()
                .padStart(2, '0')
                .let { ".${it}" }
                .dropLastWhile { it == '.' || it == '0' }
            sign + integralPart + fractionPart
        }
    }
}